import { DateRangeType, SortByType } from 'src/components/search-listing/utils/types';

/* eslint-disable import/prefer-default-export */
export enum ProfileStatus {
  unauthenticated = 'UNAUTHENTICATED',
  registered = 'REGISTERED',
  unregistered = 'UNREGISTERED',
}
export enum Redirects {
  discourse = 'DISCOURSE',
  partnerPicker = 'PARTNER_PICKER',
}

export enum ModerationState {
  silenced = 'SILENCED',
}

export type UserInfo = {
  avatarSrc?: string;
  internalUser?: boolean;
  marketplaceIds?: Array<string>;
  username: string;
  userId?: string;
  moderationState?: ModerationState;
  lastSelectedMarketplaceId?: string
  sortByPref?: SortByType
  dateRangePref?: DateRangeType
};
export interface UserInfoPayloadResponse {
  profileStatus: ProfileStatus;
  redirectTo?: Redirects
  userToken?: string;
  userInfo?: UserInfo
}

export interface UpdateUserPreferencesRequest {
  lastSelectedMarketplaceId?: string
  sortByPref?: SortByType
  dateRangePref?: DateRangeType
}
